import React, { useState } from "react";
import ToothChart from "../components/doctor/toothchart/ToothChart";

const INITIAL_STATE: Record<string, string> = {
  "36": "Filling",
  "11": "Crown",
  "26": "RCT_Done",
  "46": "Missing"
};

export default function ToothChartPreview() {
  const [toothStates] = useState(INITIAL_STATE);
  const [selected, setSelected] = useState<string[]>([]);

  const handleToothClick = (toothId: string) => {
    if (process.env.NODE_ENV === "development") {
      console.debug("Clicked:", toothId);
    }
    setSelected(prev =>
      prev.includes(toothId)
        ? prev.filter(t => t !== toothId)
        : [...prev, toothId]
    );
  };

  return (
    <div style={{
      padding: "40px",
      background: "#e2e8f0",
      minHeight: "100vh",
      display: "flex",
      flexDirection: "column",
      alignItems: "center"
    }}>
      <h2 style={{ marginBottom: "20px" }}>🧪 Tooth Chart Debug Preview</h2>

      <div style={{ background: "white", padding: "20px", borderRadius: "12px", boxShadow: "0 4px 6px rgba(0,0,0,0.1)" }}>
        <ToothChart
          toothStates={toothStates}
          selectedTeeth={selected}
          onToothClick={handleToothClick}
          readOnly={false}

        />
      </div>

      <div style={{ marginTop: "20px" }}>
        <strong>Current State Data:</strong>
        <pre>{JSON.stringify(toothStates, null, 2)}</pre>
      </div>
    </div>
  );
}
